import { useI18n } from "@/context/I18nContext";
import { Badge } from "@/components/ui/badge";
import {
    Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { OPS } from "@/constants/testIds";

const C = OPS.wm;

/**
 * Branch picker. An employee with exactly one home branch sees it LOCKED —
 * the phone form must not offer a choice that does not exist.
 */
export function WmBranchSelect({ branches, value, onChange, disabled }) {
    const { t, lang } = useI18n();
    const list = branches || [];
    const current = list.find((b) => b.id === value);
    const nameOf = (b) => (lang === "ar" ? b.name_ar || b.name_en : b.name_en || b.name_ar);

    if (list.length <= 1) {
        return (
            <div
                data-testid={C.branchSelect}
                data-locked="true"
                className="flex h-9 items-center gap-2 rounded-[var(--radius-sm)] border border-[color:var(--border-soft)] bg-[color:var(--bg-surface-2)] px-3 text-sm font-semibold text-[color:var(--ink)]"
            >
                <span className="truncate">{current ? nameOf(current) : t("wm_select_branch")}</span>
                {current && current.is_active === false ? (
                    <Badge variant="secondary" className="text-[10px] px-1.5 py-0">
                        {t("wm_badge_inactive_branch")}
                    </Badge>
                ) : null}
            </div>
        );
    }

    return (
        <Select value={value || ""} onValueChange={onChange} disabled={disabled}>
            <SelectTrigger data-testid={C.branchSelect} className="h-9 w-full">
                <SelectValue placeholder={t("wm_select_branch")} />
            </SelectTrigger>
            <SelectContent>
                {list.map((b) => (
                    <SelectItem key={b.id} value={b.id} data-testid={C.branchOption(b.id)}>
                        {nameOf(b)}
                        {b.is_active === false ? ` — ${t("wm_badge_inactive_branch")}` : ""}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    );
}
